import { CommonModule } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Member } from "@shared/models/member";
import { UpdateMember } from "@shared/models/update-member";
import { MembersService } from "@shared/services/members.service";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { UserAddressComponent } from "./user-address/user-address.component";
import { UserConsentComponent } from "./user-consent/user-consent.component";
import { UserInfoComponent } from "./user-info/user-info.component";

import { ProfilEditionComponent } from "@app/views/profil-edition/profil-edition.component";
import { MessageServiceComponent } from "@shared/components/message-service/message-service.component";
import {
  ERROR_SEVERITY,
  ERROR_SUMMARY_MESSAGE_KEY,
  SUCCESS_SEVERITY,
  SUCCESS_SUMMARY_MESSAGE_KEY,
} from "@shared/constants/message-service.constants";
import { Guid } from "guid-typescript";
import { isPartner } from "@shared/utils/brand-utils";
import { environment } from "@env/environment";

@Component({
  selector: "app-user-profile",
  standalone: true,
  templateUrl: "./user-profile.component.html",
  styleUrl: "./user-profile.component.scss",
  imports: [
    CommonModule,
    ButtonModule,
    ChangePasswordComponent,
    UserInfoComponent,
    ReactiveFormsModule,
    TranslateModule,
    UserAddressComponent,
    UserAddressComponent,
    UserConsentComponent,
    ButtonModule,
    DialogModule,
    ProfilEditionComponent,
    MessageServiceComponent,
  ],
})
export class UserProfileComponent implements OnInit {
  @ViewChild(UserInfoComponent) UserInfoComponent!: UserInfoComponent;
  @ViewChild(UserConsentComponent) UserConsentComponent!: UserConsentComponent;

  member: Member | undefined;
  isEditing = false;
  isFirstContract = false;
  showChangePassword = false;
  visibleProfilEditionDialog = false;

  messageId!: Guid;
  severityMessage!: string;
  summaryMessage!: string;
  detailMessage!: string;

  constructor(
    private readonly memberService: MembersService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit() {
    this.getMemberInformations();
  }

  getMemberInformations() {
    this.memberService.getMemberInformations().subscribe(data => {
      this.member = data;
      this.isFirstContract = data.isFirstContract;
    });
  }

  toggleEditing() {
    this.visibleProfilEditionDialog = true;
  }

  onChangePasswordToggle(show: boolean) {
    this.showChangePassword = show;
  }

  resetView() {
    if (this.showChangePassword) {
      this.showChangePassword = false;
    }
  }

  submit() {
    if (this.UserInfoComponent.isFormValid()) {
      const userInfoForm = this.UserInfoComponent.getFormData();
      const userConsentForm = this.UserConsentComponent.getFormData();
      const command: UpdateMember = {
        id: this.member?.id!,
        mobileNumber: userInfoForm.editedPhoneNumber,
        countryCode: userInfoForm.editedPhonePrefix?.prefix,
        isEmailConsents: userConsentForm.emailConsent,
        isSmsConsents: userConsentForm.smsConsent,
      };

      this.memberService.updateMemberContact(command).subscribe({
        next: () => {
          this.isEditing = false;
          this.UserInfoComponent.resetForm();
          this.memberService.getMemberInformations().subscribe(data => {
            this.member = data;
          });
        },
      });
    }
  }

  onUpdateValidation(event: boolean) {
    this.messageId = Guid.create();
    if (event) {
      this.severityMessage = SUCCESS_SEVERITY;
      this.summaryMessage = this.translate.instant(SUCCESS_SUMMARY_MESSAGE_KEY);
      this.detailMessage = this.translate.instant("common.messages.saveSuccess");
    } else {
      this.severityMessage = ERROR_SEVERITY;
      this.summaryMessage = this.translate.instant(ERROR_SUMMARY_MESSAGE_KEY);
      this.detailMessage = this.translate.instant("common.messages.saveError");
    }
  }

  onContractEditionClose() {
    this.visibleProfilEditionDialog = false;
    this.getMemberInformations();
  }

  isPartner(): boolean {
    return isPartner(environment);
  }
}
